import { Injectable } from '@angular/core';
import * as _ from 'lodash-es';
import { finance as financeData } from './data';
import { CalsoftMockApi } from 'src/app/global/mock-api/mock-api.interfaces';
import { CalsoftMockApiService } from 'src/app/global/mock-api/mock-api.service';

@Injectable({
    providedIn: 'root'
})
export class FinanceMockApi implements CalsoftMockApi
{
    // Private
    private _finance: any;

    /**
     * Constructor
     *
     * @param _calsoftMockApiService
     */
    constructor(
        private _calsoftMockApiService: CalsoftMockApiService
    )
    {
        // Set the data
        this._finance = financeData;

        // Register the API endpoints
        this.register();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Register
     */
    register(): void
    {
        // -----------------------------------------------------------------------------------------------------
        // @ Sales - GET
        // -----------------------------------------------------------------------------------------------------
        this._calsoftMockApiService
            .onGet('api/dashboards/finance')
            .reply(() => {

                return [
                    200,
                    _.cloneDeep(this._finance)
                ];
            });
    }
}
